const INITIAL_STATE = {
  items: [],
  order: { typeOrder: null },
  date: "",
  products: [],
  editProduct: null,
  selectedBranch: 0,
  modalEditOpen: false,
  idOrderModal: 0,
  observation: "Nenhuma observação",
  activeModal: { 
    order: false,
    modal: false,
  },
  errorOrder: false,
  orderTake: false,
  ordersEdit: [],
  supplyBranch: '',
};

export const Creators = {
  addDate: (date) => ({
    type: "ADD_DATE",
    date,
  }),
  orderDone: () => ({
    type: "ORDER_DONE",
  }),
};

export default function orderReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case "IMUT_ORDERS": 
      return {
        ...state,
        ordersEdit: action.ordersEdit
      }
    case "RESET":
      return {
        items: [],
        order: { typeOrder: null },
        date: "",
        products: [],
        editProduct: null,
        selectedBranch: 0,
        modalEditOpen: false,
        idOrderModal: 0,
        observation: "Nenhuma observação",
      };
    case "ADD_ITEM":
      return {
        ...state,
        items: [
          ...state.items,
          {
            id: action.item.id,
            product: action.item.product,
            quantity: action.item.quantity,
          },
        ],
      };
    case "EDIT_ITEM":
      return {
        ...state,
        ...(state.items[action.index] = action.item),
      };
    case "DELETE_ITEM":
      return {
        ...state,
        items: state.items.filter((item) => item.id !== action.item.id),
      };
    case "EDIT_SUMMARY":
      return {
        ...state,
        order: {
          typeOrder: action.typeOrder,
          items: [...state.items],
          branch: action.branch,
        },
      };
    case "EDIT_PRODUCT":
      return {
        ...state,
        editProduct: {
          id: action.id,
          product: {
            code: action.productCode,
            name: action.productName,
          },
          quantity: action.productQuantity,
        },
      };
    case "ADD_PRODUCT":
      return { ...state, products: action.products };
    case "ADD_OBSERVATION":
      return {
        ...state,
        observation: action.observation,
      };
    case "ADD_DATE":
    return { ...state, date: action.date };
    case "ORDER_DONE":
      return {
        items: [],
        order: { typeOrder: null },
        date: "",
        products: [],
        editProduct: null,
        selectedBranch: 0,
        observation: "Nenhuma observação",
        activeModal: { 
          order: false,
          modal: false,
        }
      };
    case "SELECT_BRANCH":
      return {
        ...state,
        selectedBranch: action.selectedBranch,
      };
    case "MODAL_EDIT":
      return {
        ...state,
        modalEditOpen: action.modalEdit,
      };
    case "CHANGE_ID_MODAL":
      return {
        ...state,
        idOrderModal: action.idOrder,
      };
    case "ACTIVE_ORDER_MODAL": 
      return {
        ...state,
        activeModal: action.activeModal
      }
    case "SET_ERROR_ORDER": 
      return {
        ...state,
        errorOrder: action.errorOrder
      }
    case "SET_ORDER_TAKE": 
      return {
        ...state,
        orderTake: action.orderTake
      }
    case "SET_ORDER_ITEMS": 
      return {
        ...state,
        items: action.items
      }
    case "SET_DETAILS_ORDER": 
      return {
        ...state,
        supplyBranch: action.supplyBranch
      }  
    default:
      return state;
  }
}
